export default __webpack_public_path__ + "static/media/networkSwitch.8108be9b.svg";